function timestamp(value) {
  if (value === null || value === undefined || value === '') return null;
  const input = typeof value === 'string' && /^\d+$/.test(value) ? Number(value) : value;
  const result = new Date(input).getTime();
  return Number.isFinite(result) && result > 0 ? result : null;
}

function title(value) { return typeof value === 'string' ? value.trim() : ''; }
function entries(value) { return Array.isArray(value) ? value.map((item, index) => [index, item]) : Object.entries(value || {}); }

export function normalizeCertificates(rawCertificates) {
  const seen = new Set();
  return entries(rawCertificates)
    .map(([id, certificate]) => ({
      id,
      title: title(typeof certificate === 'string' ? certificate : certificate?.certificateTitle || certificate?.title),
      issuedAt: timestamp(certificate?.issuedAt),
      verifyUrl: typeof certificate?.verifyUrl === 'string' ? certificate.verifyUrl : '',
      verificationId: certificate?.verificationId || '',
      credentialType: certificate?.credentialType || 'legacy_certificate',
    }))
    .filter((certificate) => {
      // A shared title does not make two separately issued credentials duplicates.
      const identity = certificate.verificationId || certificate.verifyUrl
        || `${certificate.credentialType}:${certificate.title}:${certificate.issuedAt || ''}`;
      if (!certificate.title || seen.has(identity)) return false;
      seen.add(identity);
      return true;
    })
    .sort((left, right) => (right.issuedAt || 0) - (left.issuedAt || 0));
}

export function normalizeAssessedBadges(rawBadges) {
  return entries(rawBadges)
    .map(([id, badge]) => ({
      id,
      title: title(typeof badge === 'string' ? badge : badge?.tag || badge?.title),
      stepTitle: title(badge?.title),
      earnedAt: timestamp(badge?.earnedAt),
      verifyUrl: typeof badge?.verifyUrl === 'string' ? badge.verifyUrl : '',
      assessed: badge?.credentialType === 'assessed_skill_badge',
    }))
    .filter((badge) => badge.title)
    .sort((left, right) => (right.earnedAt || 0) - (left.earnedAt || 0));
}
